export const removeQueryParams = (paramName: string) => {
	const params = new URLSearchParams(window.location.search);
	params.delete(paramName);
	const newSearch = params.toString();
	const newUrl = newSearch
		? `${window.location.pathname}?${newSearch}`
		: window.location.pathname;
	window.history.replaceState(null, "", newUrl);
};

export const updateQueryParams = (paramName: string, paramValue: string) => {
	const params = new URLSearchParams(window.location.search);
	params.set(paramName, paramValue.toString());
	const newUrl = `${window.location.pathname}?${params.toString()}`;
	window.history.replaceState(null, "", newUrl);
};

export const copyTextToClipboard = async (text: string) => {
	if (navigator.clipboard && window.isSecureContext) {
		try {
			await navigator.clipboard.writeText(text);
			return;
		} catch {}
	}
	const textArea = document.createElement("textarea");
	textArea.value = text;
	textArea.setAttribute("readonly", "");
	textArea.style.position = "fixed";
	textArea.style.top = "0";
	textArea.style.left = "-9999px";
	document.body.appendChild(textArea);
	textArea.select();
	const copied = document.execCommand("copy");
	document.body.removeChild(textArea);
	if (!copied) {
		throw new Error("Could not copy the text to the clipboard");
	}
};
